export const escapeCsvCell = (value) => {
  const str = value == null ? '' : String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const getCsvCellValue = (row, accessor) => {
  if (typeof accessor === 'function') {
    return accessor(row);
  }
  return row?.[accessor] ?? '';
};

export const buildCsv = (columns, data) => {
  const headers = columns.map((col) => col.header);
  const rows = data.map((row) =>
    columns.map((col) => getCsvCellValue(row, col.accessor))
  );

  return [
    headers.map(escapeCsvCell).join(','),
    ...rows.map((row) => row.map(escapeCsvCell).join(',')),
  ].join('\n');
};

export const formatExportTimestamp = () => {
  const now = new Date();
  const pad = (value) => String(value).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}`;
};

export const downloadCsvFile = (csvContent, fileName) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName.endsWith('.csv') ? fileName : `${fileName}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};

export const exportToCsv = ({
  data,
  columns,
  fileName,
  includeTimestamp = true,
}) => {
  const csv = buildCsv(columns, data);
  const resolvedFileName = includeTimestamp
    ? `${fileName}-${formatExportTimestamp()}`
    : fileName;
  downloadCsvFile(csv, resolvedFileName);
};
